<template>
  <CCard>
    <CCardHeader class="d-flex justify-content-between align-items-center">
      دانش‌آموزان
    </CCardHeader>
    <CCardBody class="d-flex align-items-center text-center h-100">
      <CDataTable
          :fields="fields"
          :items="computedAnswers"
          :loading="loadingAnswers"
          :noItemsView="{
          noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
        }"
          border
          class="w-100 d-flex justify-content-between h-100"
          fixed
          hover
          small
          striped
      >
        <template #showAnswer="{ item }">
          <td>
            <CButton
                class="modal-button"
                size="sm"
                square
                @click="onViewAnswerModal(item)"
            >
              مشاهده
            </CButton>
          </td>
        </template>
      </CDataTable>
      <ViewStudentAnswerModal
          v-model="studentAnswerViewModal"
          :answer="selectedItem"
          @get-answer="getAnswer"
      />
    </CCardBody>
    <CCardFooter class="d-flex justify-content-end">
      <CButton
          class="px-sm-5 py-2 ml-4"
          color="primary"
          size="sm"
          square
          @click="onSubmitMarks(item)"
      >
        ثبت نهایی
      </CButton>
      <CButton
          class="modal-button px-sm-5 py-2"
          size="sm"
          square
          @click="onReturn"
      >
        بازگشت
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
import axios from "@/plugins/axios";
import ViewStudentAnswerModal from "@/components/Modals/Exam/ViewStudentAnswerModal.vue";

export default {
  components: {ViewStudentAnswerModal},
  name: "addStudentMark",
  data() {
    return {
      loading: false,
      loadingAnswers: false,
      answers: [],
      student: {},
      exam: {},
      fields: [
        {key: "questionTxt", label: "سوال"},
        {key: "showAnswer", label: "مشاهده‌ی پاسخ"},
        {key: "markFull", label: "بارم"},
        {key: "mark", label: "نمره دانش‌آموز"},
      ],
      selectedItem: {},
      studentAnswerViewModal: false,
    };
  },
  computed: {
    computedAnswers() {
      return this.answers.map((item) => {
        return {
          ...item,
          questionTxt: item.question.text,
          markFull: item.question.mark,
        };
      });
    },
  },
  watch: {
    studentAnswerViewModal(newValue) {
      if (!newValue) this.selectedItem = {question: {}};
    },
  },
  mounted() {
    this.getStudent();
    this.getExam();
    this.getAnswer();
  },
  methods: {
    async getAnswer(routeName) {
      try {
        this.loadingAnswers = true;
        const {id: examId} = this.$route.params;

        const {studentId: studentId} = this.$route.params;
        const {data} = await axios.get(`/exam/${examId}/answer`, {
          params: {studentId: studentId},
        });
        this.answers = data;

        routeName = `${this.exam.title} / ${this.student.name} ${this.student.lastname}`;
        this.$emit("go-to", routeName);
      } catch (error) {
        console.log("errrror:", error);
      } finally {
        this.loadingAnswers = false;
      }
    },
    async getStudent(routeName) {
      try {
        this.loading = true;
        const {studentId: studentId} = this.$route.params;
        const {data} = await axios.get(`/student/${studentId}`);
        this.student = data;
      } catch (error) {
        console.log("errrror:", error);
      } finally {
        this.loading = false;
      }
    },
    async getExam(routeName) {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;

        const {studentId: studentId} = this.$route.params;
        const {data} = await axios.get(`/exam/${examId}`);
        this.exam = data;
      } catch (error) {
        console.log("errrror:", error);
      } finally {
        this.loading = false;
      }
    },
    async onSubmitMarks() {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const {studentId: studentId} = this.$route.params;
        await axios.put(`/exam/${examId}/answer/student/${studentId}`);
        this.$router.push(`/${this.$type}/exam/${examId}`);
      } catch (error) {
        console.log("errrrrrror:", error);
      } finally {
        this.loading = false;
      }
    },
    onViewAnswerModal(item) {
      this.selectedItem = item;
      this.studentAnswerViewModal = true;
    },
    onReturn() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped></style>